export const CARD_WIDTH = 150;
export const CARD_GAP = 8;

const SIZE_PRIORITY = {
  '1x2': 0,
  '1x1': 1,
  '2x1': 2,
};

export const getVisibleWidgetIds = (groupedWidgets) => {
  const visibleWidgetIds = new Set();

  groupedWidgets.forEach((category) => {
    category.subItems.forEach((subCategory) => {
      subCategory.widgets.forEach((widget) => {
        visibleWidgetIds.add(String(widget.id));
      });
    });
  });

  return visibleWidgetIds;
};

export const getCardsPerRow = (containerWidth) => {
  if (!containerWidth || containerWidth <= 0) {
    return 1;
  }

  return Math.max(1, Math.floor((containerWidth + CARD_GAP) / (CARD_WIDTH + CARD_GAP)));
};

export const chunkWidgets = (widgets, size) => {
  if (!Array.isArray(widgets) || !widgets.length) {
    return [];
  }

  const chunkSize = Math.max(1, size);
  const chunks = [];

  for (let index = 0; index < widgets.length; index += chunkSize) {
    chunks.push(widgets.slice(index, index + chunkSize));
  }

  return chunks;
};

export const getOrderedSizes = (sizes) =>
  [...sizes].sort((first, second) => (SIZE_PRIORITY[first] ?? 99) - (SIZE_PRIORITY[second] ?? 99));

export const getSizeAspectRatio = (size) => {
  const [width, height] = String(size)
    .split('x')
    .map((value) => Number(value));

  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return '1 / 1';
  }

  return `${width} / ${height}`;
};

export const getPreviewMinHeight = (size) => {
  switch (size) {
    case '1x2':
      return 128;
    case '2x1':
      return 75;
    default:
      return 90;
  }
};
